import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  toggleDisabled (e) {
    const targetFields = e.target.closest('tr').getElementsByClassName('vacancy-field')
    if (e.target.checked) {
      Array.prototype.forEach.call(targetFields, (field) => {
        field.disabled = false
      })
    } else {
      Array.prototype.forEach.call(targetFields, (field) => {
        field.disabled = true
      })
    }
  }
}
